module.exports = __webpack_public_path__ + "885e0b3538aa4fc1e8353487b65c8f2c.svg"